const DRAG_PAGE_THRESHOLD = 0.2;

interface DragTargetPageParams {
  startPage: number;
  translationX: number;
  pageWidth: number;
  lastPage: number;
}

export const getDragTargetPage = ({
  startPage,
  translationX,
  pageWidth,
  lastPage,
}: DragTargetPageParams) => {
  'worklet';
  const draggedPages = -translationX / pageWidth;
  const direction =
    Math.abs(draggedPages) > DRAG_PAGE_THRESHOLD ? Math.sign(draggedPages) : 0;
  return Math.min(Math.max(startPage + direction, 0), lastPage);
};
